<template>
    <yxt-input
      v-model.trim="getValue"
      :placeholder="$t('pc_biz_pleaseInputCourseAddress'/* 请输入课程地点 */)"
      maxlength="50"
      show-word-limit
      v-bind="$attrs.attrs"
      v-on="$attrs.on"
    />
</template>
<script>
export default {
  name: 'LiveLocation',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped lang="less"></style>
